import { createSlice } from "@reduxjs/toolkit";

const initialState = {
    targetKpi: "",
    correspondingKpi: [],
};

export const driverAnalysisStore = createSlice({
    name: "driverAnalysisStore",
    initialState,
    reducers: {
        loadTargetKpiState: (state, action) => {
            state.targetKpi = action.payload;
        },
        loadCorrespondingKpiState: (state, action) => {
            state.correspondingKpi = action.payload;
        },
        resetDriverAnalysisStore: () => initialState,
    },
});

export const { loadTargetKpiState, loadCorrespondingKpiState, resetDriverAnalysisStore } = driverAnalysisStore.actions;

export default driverAnalysisStore.reducer;
